import { create } from "zustand";

/**
 * 시나리오 훈련(모의훈련) 모드 세션 상태 — 협약 대시보드 기능 #12.
 *
 * 관제요원이 훈련을 시작하면 화면 전체에 "훈련 중" 워터마크가 뜨고, 그동안
 * 발생한 경보(실데이터든 P5-A Validator 시뮬레이터 재생이든)의 시각·등급을
 * 기록한다. 종료 시 결과 요약(첫 경보까지의 감지 지연, 훈련 소요, 경보 목록)을
 * 낸다. 실경보와 훈련경보를 사람이 구분할 수 있도록 워터마크는 항상 표시된다.
 *
 * 트리거는 클라이언트 세션 관리만 담당한다 — 실제 가스 주입은 P5-A Validator
 * 시뮬레이터(CLI)가 노드로 데이터를 밀어넣고, 그 결과 발생한 경보를 여기서
 * 수신·계측한다(트리거 API 부재 → 재생 안내는 패널에서 제공).
 */

export interface TrainingAlarmEvent {
  /** 경보 id (중복 억제용). */
  alertId: number | null;
  level: number;
  gas: string;
  siteId: number | null;
  /** 수신 시각 (epoch ms). */
  at: number;
}

interface TrainingModeState {
  active: boolean;
  scenarioName: string | null;
  /** 훈련 시작 시각 (epoch ms). */
  startedAt: number | null;
  /** 훈련 종료 시각 (epoch ms) — 결과 요약 표시 중이면 값이 있음. */
  endedAt: number | null;
  events: TrainingAlarmEvent[];

  start: (scenarioName: string) => void;
  /** 훈련을 종료하고 결과 요약 상태로 전환. */
  stop: () => void;
  /** 결과 요약을 닫고 완전 초기화. */
  reset: () => void;
  /** 훈련 중 발생한 경보 1건 기록(alertId 로 중복 억제). */
  recordAlarm: (e: TrainingAlarmEvent) => void;
}

export const useTrainingMode = create<TrainingModeState>((set, get) => ({
  active: false,
  scenarioName: null,
  startedAt: null,
  endedAt: null,
  events: [],

  start: (scenarioName) =>
    set({ active: true, scenarioName, startedAt: Date.now(), endedAt: null, events: [] }),
  stop: () => set({ active: false, endedAt: Date.now() }),
  reset: () =>
    set({ active: false, scenarioName: null, startedAt: null, endedAt: null, events: [] }),
  recordAlarm: (e) => {
    if (!get().active) return;
    // 같은 경보 id 는 한 번만.
    if (e.alertId != null && get().events.some((x) => x.alertId === e.alertId)) return;
    set((s) => ({ events: [...s.events, e] }));
  },
}));
